module.exports = __webpack_public_path__ + "img/image_2.5796ddd9.jpg";